import Vue from 'vue';
import Router from 'vue-router';
import vuex from '../store/index.js'
import activityList from '../components/pages/activityList.vue'//活动列表
import activityInfo from '../components/pages/activityInfo.vue'//活动详情
import productInfo from '../components/pages/productInfo.vue'//商品详情
import orderList from '../components/pages/orderList.vue'//订单列表
import orderSubmit from '../components/pages/orderSubmit.vue'//订单提交页
import orderThen from '../components/pages/orderThen.vue'//付款结果页
import orderIng from '../components/pages/orderIng.vue'//新订单详情页
import orderInfo from '../components/pages/orderInfo.vue'//订单详情页
import returnOrder from '../components/pages/returnOrder.vue'//退款页面
import returnOrderList from '../components/pages/returnOrderList.vue'//退款列表
import returnOrderInfo from '../components/pages/returnOrderInfo.vue'//退款详情
import userCenter from '../components/pages/userCenter.vue'//个人中心页
import weChat from '../components/pages/weChat.vue' //微信登录跳转页
import addressList from '../components/pages/addressList.vue'//用户地址列表页
import addressEdit from '../components/pages/addressEdit.vue' //用户地址编辑页
import selfLiftingPoint from '../components/pages/selfLiftingPoint.vue'//自提点选择页
import cart from '../components/pages/cart.vue'//自提点选择页
import searchList from '../components/pages/searchList.vue'//搜索商品页
import versionTood from  '../utils/versionUpdate.js'
Vue.use(Router);
import { Dialog } from 'vant';
const router=new Router({
	routes:[
        {
            path: '/',
			component: activityList,
            meta: { title: '贡秋团购' ,keepAlive:true},
			
        }, 
		{
		    path: '/activityList',
			component: activityList,
		    meta: { title: '活动列表' ,keepAlive:false},		
		}, 
		
		{
		    path:'/activityInfo',
			component: activityInfo,
		    meta: { title: '活动详情' ,keepAlive:true,},
			// props: true
		}, 
        {
            path: '/productInfo',
			component: productInfo,
            meta: { title: '商品详情' ,keepAlive:false},
			// props: true
        },
		{
		    path: '/orderSubmit',
			component: orderSubmit,
		    meta: { title: '订单提交' ,keepAlive:false}
		},
		{
		    path: '/orderThen',
			component: orderThen,
		    meta: { title: '支付结果' ,keepAlive:false},
			// props:true
		},
		{
		    path: '/orderIng',
			component: orderIng,
		    meta: { title: '订单页',keepAlive:false },
			// props:true
		},
		{
		    path: '/userCenter',
			component: userCenter,
		    meta: { title: '我的' ,keepAlive:false}
		},
		{
		    path: '/orderList',
			component: orderList,
		    meta: { title: '订单列表' ,keepAlive:false}
		},
		{
		    path: '/orderInfo',
			component: orderInfo,
		    meta: { title: '订单详情' ,keepAlive:false},
			// props:true
		},
		{
		    path: '/returnOrder',
			component: returnOrder,
		    meta: { title: '退款售后' ,keepAlive:false},
		},
		{
		    path: '/returnOrderList',
			component: returnOrderList,
		    meta: { title: '退款售后列表' ,keepAlive:false},
		},
		{
		    path: '/returnOrderInfo',
			component: returnOrderInfo,
		    meta: { title: '退款售后详情' ,keepAlive:false},
		},
		{
		    path: '/weChat',
			component: weChat,
		    meta: { title: '正在登录...' ,keepAlive:false}
		},
		{
		    path: '/addressList',
			component: addressList,
		    meta: { title: '用户地址列表',keepAlive:false }
		},
		{
			path: '/addressEdit',
			component: addressEdit,
			meta: { title: '地址编辑' ,keepAlive:false}
		},
		{
			path: '/selfLiftingPoint',
			component: selfLiftingPoint,
			meta: { title: '自提点' ,keepAlive:false},
		},	
		{
			path: '/cart',
			component: cart,
			meta: { title: '购物车' ,keepAlive:false},
		},
		{
			path: '/searchList',
			component: searchList,
			meta: { title: '商品搜索' ,keepAlive:true},
		},
		{
			path: '*',
			component: activityList,
			meta: { title: '贡秋团购' ,keepAlive:true},
		},
    ],
	//解决页面位置顶部
	 // scrollBehavior() {
	 //        return {x: 0, y: 0};
	 //    }

})
	router.beforeEach((to, from, next) => {
		//判断是否有新版本
		versionTood.isNewVersion();
		if(['/','/activityList','/activityInfo','/productInfo','/userCenter', '/weChat','/cart','/searchList'].indexOf(to.path) != -1 || vuex.state.token){
			next()
		
		} else {
			
			next('/userCenter')			
		}
		// 判断页面定位到顶部
		
		
		if(to.path !== '/activityInfo'){
			document.documentElement.scrollTop = 0
		}
		// else{
		// 	if(from.path =="/" || from.path =='/activityList'){
		// 		document.documentElement.scrollTop = 0
		// 	}
		// }
		
	
	})
export default router